import { render, staticRenderFns } from "./TemplateSelection.vue?vue&type=template&id=2bffd398&scoped=true&"
import script from "./TemplateSelection.vue?vue&type=script&lang=ts&"
export * from "./TemplateSelection.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSelection.vue?vue&type=style&index=0&id=2bffd398&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bffd398",
  null
  
)

export default component.exports